// Single source of truth for the Supabase URL/key/project-id used by the
// React app. Values come exclusively from environment variables — no
// production identifiers are baked into source. Stagings configure their
// own backend via VITE_STANDALONE_SUPABASE_URL / _PUBLISHABLE_KEY.

const URL_FROM_ENV = import.meta.env.VITE_STANDALONE_SUPABASE_URL as string | undefined;
const KEY_FROM_ENV = import.meta.env.VITE_STANDALONE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

if (!URL_FROM_ENV) {
  throw new Error(
    "VITE_STANDALONE_SUPABASE_URL is not set. Configure it in your environment.",
  );
}
if (!KEY_FROM_ENV) {
  throw new Error(
    "VITE_STANDALONE_SUPABASE_PUBLISHABLE_KEY is not set. Configure it in your environment.",
  );
}

export const SUPABASE_URL: string = URL_FROM_ENV;
export const SUPABASE_PUBLISHABLE_KEY: string = KEY_FROM_ENV;
export const SUPABASE_PROJECT_ID: string =
  SUPABASE_URL.match(/^https:\/\/([^.]+)\.supabase\.co/)?.[1] || "";
